import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { WaitlistPage } from './pages/WaitlistPage';
import { LegalPage } from './pages/LegalPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-cream flex flex-col" data-id="element-1">
        <Navigation data-id="element-2" />
        <div className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/features" element={<FeaturesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/pricing" element={<PricingPage data-id="element-10" />} data-id="element-9" />
            <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
            <Route path="/blog" element={<BlogPage data-id="element-14" />} data-id="element-13" />
            <Route path="/waitlist" element={<WaitlistPage data-id="element-16" />} data-id="element-15" />
            <Route path="/legal" element={<LegalPage data-id="element-18" />} data-id="element-17" />
          </Routes>
        </div>
        <Footer data-id="element-19" />
      </div>
    </BrowserRouter>;
}